import { FunctionComponent, h } from 'preact';

import { CountryCodeEnum } from 'common/data/country/code.enum';
import { PropertyModel } from 'common/data/property/model';
import { configGetCountry } from 'common/helper/config/get-country';
import { domClassMerge } from 'common/helper/dom/class-merge';
import { LazyLoadingComponent } from 'common/module/lazy-loading/component';
import { ProgressiveImageComponent } from 'common/module/progressive-image/component';
import { PropertyCardTagTemplate } from 'common/module/property/card/tag-template';
import { PropertyOffPlanTagsComponent } from 'common/module/property-off-plan-tags/component';
import { PropertyCardSectionsPriceInclusiveTemplate } from 'desktop/module/property/card/sections/price-inclusive/template';

export const PropertyCardSectionsIntroTemplate: FunctionComponent<{
  brokerImageBig?: boolean;
  property: PropertyModel;
  showTag?: boolean;
  brokerImageVisible?: boolean;
}> = ({ brokerImageBig = false, property, showTag = true, brokerImageVisible = true }) => {
  /**
   * Check if new project property
   */
  const isNewProjectProperty = property.new_projects;
  const isBrokerProjectProperty = property.is_broker_project_property;
  const isBH = configGetCountry().code === CountryCodeEnum.bh;
  const utilitiesPriceType = property.utilities_price_type;

  return (
    <div className='card-intro'>
      <div className='card-intro__left'>
        {property?.property_type?.name && <p className='card-intro__type'>{property.property_type.name}</p>}
        <div
          className={domClassMerge('card-intro__price-area', {
            'card-intro__price-area--aligned': isBH,
          })}
        >
          <p className='card-intro__price'>{property.meta.price_text}</p>
          <PropertyCardSectionsPriceInclusiveTemplate utilityPriceType={utilitiesPriceType} />
        </div>
        {isNewProjectProperty && property.project && <PropertyOffPlanTagsComponent project={property.project} />}
        <h2 className='card-intro__title'>{property.name}</h2>
      </div>
      <div className='card-intro__right'>
        {showTag && (
          <PropertyCardTagTemplate
            class='card-intro__tag'
            listingLevel={property.listing_level}
            featured={property.featured}
            premium={property.premium}
            classNamePrefix='card-intro__tag'
          />
        )}
        <LazyLoadingComponent visible={brokerImageVisible}>
          <ProgressiveImageComponent
            src={
              isNewProjectProperty && !isBrokerProjectProperty && !property.project?.developer?.logo_token
                ? __('assets/common/developer-default-logo.jpg')
                : brokerImageBig
                ? property.broker.links.logo_178_98
                : property.links.image_broker
            }
            classname='card-intro__broker'
            pictureClass='card-intro__broker-image'
            placeholder={__('assets/common/broker-tile-placeholder.jpg')}
          />
        </LazyLoadingComponent>
      </div>
    </div>
  );
};
